import { render, staticRenderFns } from "./vantBindMerchantList.vue?vue&type=template&id=136b0a80&scoped=true"
import script from "./vantBindMerchantList.vue?vue&type=script&lang=ts"
export * from "./vantBindMerchantList.vue?vue&type=script&lang=ts"
import style0 from "./vantBindMerchantList.vue?vue&type=style&index=0&id=136b0a80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b0a80",
  null
  
)

export default component.exports